
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.13.0
 * Query Engine version: 1e7af066ee9cb95cf3a403c78d9aab3e6b04f37a
 */
Prisma.prismaVersion = {
  client: "4.13.0",
  engine: "1e7af066ee9cb95cf3a403c78d9aab3e6b04f37a"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val


/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state',
  oauth_token_secret: 'oauth_token_secret',
  oauth_token: 'oauth_token'
};

exports.Prisma.AdminActivityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  description: 'description',
  data: 'data',
  adminEmail: 'adminEmail'
};

exports.Prisma.AdminScalarFieldEnum = {
  email: 'email',
  password: 'password'
};

exports.Prisma.AvailableFundsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  amount: 'amount'
};

exports.Prisma.CertificateScalarFieldEnum = {
  id: 'id',
  source: 'source',
  url: 'url',
  description: 'description',
  companyDraftId: 'companyDraftId'
};

exports.Prisma.CompanyDraftScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  codatCompanyId: 'codatCompanyId',
  registeredId: 'registeredId',
  name: 'name',
  finishOnboardingAttemptedAt: 'finishOnboardingAttemptedAt',
  userId: 'userId',
  futureCompanyId: 'futureCompanyId'
};

exports.Prisma.CompanyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  registeredId: 'registeredId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  logo: 'logo',
  registrationSource: 'registrationSource',
  type: 'type',
  creatorId: 'creatorId',
  codatCompanyId: 'codatCompanyId',
  companyDraftId: 'companyDraftId',
  mandateId: 'mandateId'
};

exports.Prisma.ConversionRateSnapshotScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  baseRate: 'baseRate',
  slippageCoverageAmount: 'slippageCoverageAmount',
  rate: 'rate',
  source: 'source',
  target: 'target'
};

exports.Prisma.CreditLimitDecisionScalarFieldEnum = {
  id: 'id',
  recommendedMaxPotentialLimit: 'recommendedMaxPotentialLimit',
  recommendedMaxAvailableLimit: 'recommendedMaxAvailableLimit',
  createdAt: 'createdAt',
  creditScore: 'creditScore',
  source: 'source',
  bondRatingEquivalent: 'bondRatingEquivalent',
  companyId: 'companyId',
  creditTrustCoefficient: 'creditTrustCoefficient',
  aprDiscount: 'aprDiscount',
  approvalRating: 'approvalRating'
};

exports.Prisma.CreditSafeReportScalarFieldEnum = {
  id: 'id',
  score: 'score',
  maxScore: 'maxScore',
  rating: 'rating',
  createdAt: 'createdAt',
  companyRegisteredId: 'companyRegisteredId',
  creditSafeCompanyId: 'creditSafeCompanyId'
};

exports.Prisma.DiscountScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  percentage: 'percentage',
  createdAt: 'createdAt',
  source: 'source'
};

exports.Prisma.FinancialDataConnectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  type: 'type',
  source: 'source',
  status: 'status',
  externalId: 'externalId'
};

exports.Prisma.FinancialSnapshotScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  date: 'date',
  balance: 'balance',
  codatCompanyId: 'codatCompanyId',
  source: 'source'
};

exports.Prisma.InstalmentScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  loanAmount: 'loanAmount',
  fixedFeeAmount: 'fixedFeeAmount',
  amount: 'amount',
  createdAt: 'createdAt',
  chargeAt: 'chargeAt',
  processor: 'processor',
  externalId: 'externalId',
  currentStatus: 'currentStatus',
  repaymentScheduleId: 'repaymentScheduleId'
};

exports.Prisma.InvoiceDocumentScalarFieldEnum = {
  id: 'id',
  source: 'source',
  storageId: 'storageId',
  createdAt: 'createdAt',
  creatorId: 'creatorId',
  companyId: 'companyId'
};

exports.Prisma.InvoiceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  externalId: 'externalId',
  amount: 'amount',
  currency: 'currency',
  vendorName: 'vendorName',
  vendorRegisteredId: 'vendorRegisteredId',
  vendorCountry: 'vendorCountry',
  vendorId: 'vendorId',
  loanDraftId: 'loanDraftId',
  userId: 'userId',
  invoiceDocumentId: 'invoiceDocumentId',
  loanId: 'loanId',
  companyId: 'companyId'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.KYCProcessScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  externalProcessId: 'externalProcessId',
  externalProcessActorId: 'externalProcessActorId',
  externalEntityId: 'externalEntityId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  source: 'source'
};

exports.Prisma.LendingContractScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  companyId: 'companyId',
  userId: 'userId',
  status: 'status',
  signedAt: 'signedAt',
  externalId: 'externalId',
  userExternalId: 'userExternalId',
  signPageUrl: 'signPageUrl',
  invoiceId: 'invoiceId',
  source: 'source'
};

exports.Prisma.LoanDecisionLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  loanDraftId: 'loanDraftId',
  note: 'note',
  decision: 'decision',
  adminEmail: 'adminEmail'
};

exports.Prisma.LoanDraftScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  date: 'date',
  term: 'term',
  amount: 'amount',
  currency: 'currency',
  conversionFee: 'conversionFee',
  conversionFeePercentage: 'conversionFeePercentage',
  conversionRateSnapshotId: 'conversionRateSnapshotId',
  repaymentScheduleId: 'repaymentScheduleId',
  discountIds: 'discountIds'
};

exports.Prisma.LoanScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  date: 'date',
  term: 'term',
  amount: 'amount',
  currency: 'currency',
  conversionFee: 'conversionFee',
  conversionFeePercentage: 'conversionFeePercentage',
  conversionRateSnapshotId: 'conversionRateSnapshotId',
  subscriptionId: 'subscriptionId',
  loanDraftId: 'loanDraftId',
  repaymentScheduleId: 'repaymentScheduleId',
  discountIds: 'discountIds'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.ReceiptScalarFieldEnum = {
  id: 'id',
  source: 'source',
  storageId: 'storageId',
  createdAt: 'createdAt',
  instalmentId: 'instalmentId'
};

exports.Prisma.RepaymentScheduleScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  term: 'term',
  loanAmount: 'loanAmount',
  fixedFeeAmount: 'fixedFeeAmount',
  amount: 'amount',
  fixedFeePercentage: 'fixedFeePercentage',
  createdAt: 'createdAt'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.TermCalculationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  term: 'term',
  companyId: 'companyId',
  financialSnapshotIds: 'financialSnapshotIds'
};

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.TreesPlantedScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  companyId: 'companyId',
  invoiceId: 'invoiceId',
  numberOfTreesPlanted: 'numberOfTreesPlanted',
  projectName: 'projectName',
  treeUrl: 'treeUrl'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  companyId: 'companyId',
  companyDraftId: 'companyDraftId'
};

exports.Prisma.VendorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  registeredId: 'registeredId',
  country: 'country',
  createdByCompanyId: 'createdByCompanyId'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.WiserfundingReportReferenceScalarFieldEnum = {
  id: 'id',
  registeredCompanyId: 'registeredCompanyId',
  codatCompanyId: 'codatCompanyId',
  baseWiserFundingReportId: 'baseWiserFundingReportId',
  baseWiserFundingReportCreatedAt: 'baseWiserFundingReportCreatedAt',
  codatWiserFundingReportId: 'codatWiserFundingReportId',
  codatWiserFundingReportCreatedAt: 'codatWiserFundingReportCreatedAt',
  createdAt: 'createdAt'
};
exports.BondRating = {
  AA: 'AA',
  AA_MINUS: 'AA_MINUS',
  A_PLUS: 'A_PLUS',
  A: 'A',
  A_MINUS: 'A_MINUS',
  BBB_PLUS: 'BBB_PLUS',
  BBB: 'BBB',
  BBB_MINUS: 'BBB_MINUS',
  BB_PLUS: 'BB_PLUS',
  BB: 'BB',
  BB_MINUS: 'BB_MINUS',
  B_PLUS: 'B_PLUS',
  B: 'B',
  B_MINUS: 'B_MINUS',
  CCC_PLUS: 'CCC_PLUS',
  CCC: 'CCC',
  CCC_MINUS: 'CCC_MINUS',
  CC_PLUS: 'CC_PLUS',
  CC: 'CC',
  CC_MINUS: 'CC_MINUS',
  D: 'D'
};

exports.CertificateSource = {
  ONE_PERCENT_FOR_THE_PLANET: 'ONE_PERCENT_FOR_THE_PLANET',
  B_CORP: 'B_CORP',
  CLIMATE_NEUTRAL: 'CLIMATE_NEUTRAL',
  B_CORP_PENDING: 'B_CORP_PENDING',
  PLANET_MARK: 'PLANET_MARK',
  OTHERS: 'OTHERS'
};

exports.CompanyType = {
  LIMITED: 'LIMITED'
};

exports.Country = {
  Albania: 'Albania',
  Austria: 'Austria',
  Belarus: 'Belarus',
  Belgium: 'Belgium',
  Bosnia_and_Herzegovina: 'Bosnia_and_Herzegovina',
  Bulgaria: 'Bulgaria',
  China: 'China',
  Croatia: 'Croatia',
  Cyprus: 'Cyprus',
  Czech_Republic: 'Czech_Republic',
  Denmark: 'Denmark',
  Estonia: 'Estonia',
  Finland: 'Finland',
  France: 'France',
  Germany: 'Germany',
  Greece: 'Greece',
  Hungary: 'Hungary',
  Iceland: 'Iceland',
  India: 'India',
  Ireland: 'Ireland',
  Italy: 'Italy',
  Kosovo: 'Kosovo',
  Latvia: 'Latvia',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lithuania',
  Luxembourg: 'Luxembourg',
  Malta: 'Malta',
  Moldova: 'Moldova',
  Monaco: 'Monaco',
  Montenegro: 'Montenegro',
  Netherlands: 'Netherlands',
  North_Macedonia: 'North_Macedonia',
  Norway: 'Norway',
  Poland: 'Poland',
  Portugal: 'Portugal',
  Romania: 'Romania',
  Russian_Federation: 'Russian_Federation',
  Serbia: 'Serbia',
  Slovakia: 'Slovakia',
  Slovenia: 'Slovenia',
  Spain: 'Spain',
  Sweden: 'Sweden',
  Switzerland: 'Switzerland',
  Turkey: 'Turkey',
  Ukraine: 'Ukraine',
  United_Kingdom: 'United_Kingdom'
};

exports.CreditLimitDecisionSource = {
  WISER_FUNDING: 'WISER_FUNDING',
  KIKIN_ALT_CALCULATION: 'KIKIN_ALT_CALCULATION',
  MANUAL_ADMIN_ADJUSTMENT: 'MANUAL_ADMIN_ADJUSTMENT',
  WF_FALLBACK: 'WF_FALLBACK'
};

exports.Currency = {
  GBP: 'GBP',
  EUR: 'EUR',
  USD: 'USD',
  TRY: 'TRY',
  ALL: 'ALL',
  AMD: 'AMD',
  AZN: 'AZN',
  BYN: 'BYN',
  BAM: 'BAM',
  BGN: 'BGN',
  CZK: 'CZK',
  DKK: 'DKK',
  GEL: 'GEL',
  HUF: 'HUF',
  ISK: 'ISK',
  CHF: 'CHF',
  MDL: 'MDL',
  MKD: 'MKD',
  NOK: 'NOK',
  PLN: 'PLN',
  RON: 'RON',
  RUB: 'RUB',
  RSD: 'RSD',
  SEK: 'SEK',
  UAH: 'UAH'
};

exports.DiscountSource = {
  ADMIN: 'ADMIN'
};

exports.FinancialDataConnectionSource = {
  CODAT: 'CODAT',
  OFFLINE: 'OFFLINE'
};

exports.FinancialDataConnectionStatus = {
  PENDING_AUTH: 'PENDING_AUTH',
  LINKED: 'LINKED',
  DEAUTHORIZED: 'DEAUTHORIZED',
  UNLINKED: 'UNLINKED'
};

exports.FinancialDataConnectionType = {
  ACCOUNTING: 'ACCOUNTING',
  BANKING: 'BANKING',
  COMMERCE: 'COMMERCE',
  OTHER: 'OTHER'
};

exports.FinancialSnapshotSource = {
  CODAT: 'CODAT',
  OFFLINE: 'OFFLINE'
};

exports.InstalmentProcesser = {
  GOCARDLESS: 'GOCARDLESS',
  INTERNAL: 'INTERNAL'
};

exports.InstalmentStatus = {
  VOID: 'VOID',
  APPROXIMATE: 'APPROXIMATE',
  SCHEDULED: 'SCHEDULED',
  COMMITTED: 'COMMITTED',
  PAID: 'PAID'
};

exports.InvoiceSource = {
  SUPABASE: 'SUPABASE'
};

exports.InvoiceStatus = {
  REJECTED: 'REJECTED',
  DRAFT: 'DRAFT',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED_PENDING_PAYMENT: 'APPROVED_PENDING_PAYMENT',
  PAID: 'PAID',
  PAID_BACK: 'PAID_BACK'
};

exports.KYCProcessSource = {
  CREDAS: 'CREDAS'
};

exports.KYCProcessStatus = {
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE'
};

exports.LendingContractSource = {
  E_SIGNATURES: 'E_SIGNATURES'
};

exports.LendingContractStatus = {
  PENDING: 'PENDING',
  SIGNED: 'SIGNED'
};

exports.LoanDecision = {
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED'
};

exports.RegistrationSource = {
  COMPANIES_HOUSE: 'COMPANIES_HOUSE'
};

exports.Prisma.ModelName = {
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  VerificationToken: 'VerificationToken',
  Company: 'Company',
  CreditLimitDecision: 'CreditLimitDecision',
  Certificate: 'Certificate',
  CompanyDraft: 'CompanyDraft',
  WiserfundingReportReference: 'WiserfundingReportReference',
  Admin: 'Admin',
  InvoiceDocument: 'InvoiceDocument',
  Receipt: 'Receipt',
  Invoice: 'Invoice',
  LoanDraft: 'LoanDraft',
  Loan: 'Loan',
  RepaymentSchedule: 'RepaymentSchedule',
  Instalment: 'Instalment',
  FinancialSnapshot: 'FinancialSnapshot',
  TermCalculation: 'TermCalculation',
  AdminActivity: 'AdminActivity',
  TreesPlanted: 'TreesPlanted',
  CreditSafeReport: 'CreditSafeReport',
  LendingContract: 'LendingContract',
  Discount: 'Discount',
  AvailableFunds: 'AvailableFunds',
  KYCProcess: 'KYCProcess',
  ConversionRateSnapshot: 'ConversionRateSnapshot',
  Vendor: 'Vendor',
  FinancialDataConnection: 'FinancialDataConnection',
  LoanDecisionLog: 'LoanDecisionLog'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
